/**
 * Endeavor Practices — the founder's methodology.
 *
 * Verb-led on purpose. A Practice is what the human needs to DO; the Place it
 * happens in is routing detail the user should not have to carry. Adding a
 * Practice is one entry here — no component changes.
 *
 * FOUNDER-AUTHORED CONTENT ONLY. Nothing in this file is invented copy.
 */

export const PRACTICES = [
  {
    key: "playcard",
    verb: "New or Update Challenge PlayCard",
    note: "Name the aim out loud, then put something behind it.",
    realm: "playforward",
    where: "the Cove · Pursuital Arcade",
    to: "/playforward/cove",
    ready: true,
  },
  {
    key: "shards",
    verb: "Dump Shards of Ideas",
    note: "One thought per Shard, straight onto the Graffiti Wall. Unsorted is the job.",
    realm: "stageward",
    where: "the Green Room · Clarity Hall",
    to: "/stageward",
    ready: true,
  },
  {
    key: "sort",
    verb: "Pay to Sort the Bench",
    note: "MelzAI clusters what you dumped. It costs, so it counts.",
    realm: "stageward",
    where: "the Green Room · Clarity Hall",
    to: "/stageward/table",
    ready: true,
  },
  {
    key: "date",
    verb: "Date the Sequence at the Desk",
    note: "An order without dates is still a wish. Leave with a Blueprint you can print.",
    realm: "stageward",
    where: "the Design Desk · Clarity Hall",
    to: "/stageward/desk",
    ready: true,
  },
  {
    key: "mission",
    verb: "Set a Mission and Take a Mark",
    note: "One Mission. A Mark moves zero Tokens, by design.",
    realm: "stageward",
    where: "the Green Room · Clarity Hall",
    to: "/stageward/mission",
    ready: true,
  },
];

/** The Journey tab. One thread through both realms. */
export const JOURNEY_TABS = ["Practices", "Journey", "The World"];
